// Wild Palace — "Save cart for later" (Klaviyo email capture) submit handler.
//
// This lives in a real page script (loaded once from snippets/scripts.liquid) rather
// than an inline <script> inside snippets/wild-save-cart.liquid ON PURPOSE: the cart
// drawer re-renders via morphSection (assets/component-cart-items.js), and morph does
// NOT re-execute inline <script> tags (see assets/morph.js — "browsers don't re-execute
// them"). So when the drawer is populated by AJAX (the normal add-to-cart flow), an inline
// handler was never attached — the form (which has no method/action) then did a native GET
// submit, reloading the page / closing the drawer, and never firing the Klaviyo event.
//
// The handler is document-delegated + self-guarded, so registering it once on page load
// catches the save-cart form whether it's server-rendered on /cart OR morphed into the
// drawer. Integration contract unchanged: relies on Klaviyo's onsite object (window.klaviyo
// or legacy window._learnq) + the public client-subscriptions endpoint; all IDs/labels come
// from the form's data-* attributes (theme settings).
(function () {
  if (window.__wpSaveCart) return;
  window.__wpSaveCart = true;

  function showMsg(msg, text, isError) {
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
    msg.classList.toggle('wild-savecart__msg--error', !!isError);
  }

  function klaviyo() {
    return window.klaviyo || window._learnq;
  }

  function fireKlaviyo(email, evt, cart) {
    var items = (cart.items || []).map(function (it) {
      return {
        ProductID: it.product_id,
        ProductName: it.product_title || it.title,
        Variant: it.variant_title || '',
        Quantity: it.quantity,
        ItemPrice: (it.final_price || 0) / 100,
        URL: location.origin + it.url,
        Image: it.image,
      };
    });
    var payload = {
      $value: (cart.total_price || 0) / 100,
      Currency: cart.currency,
      ItemNames: items.map(function (i) {
        return i.ProductName;
      }),
      Items: items,
      CheckoutURL: location.origin + '/cart',
    };
    try {
      var kl = klaviyo();
      if (kl && typeof kl.push === 'function') {
        kl.push(['identify', { $email: email }]);
        kl.push(['track', evt, payload]);
      } else if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ $email: email });
        if (typeof window.klaviyo.track === 'function') window.klaviyo.track(evt, payload);
      }
    } catch (e) {}
  }

  function subscribeList(email, key, list) {
    if (!key || !list) return;
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } },
            relationships: { list: { data: { type: 'list', id: list } } },
          },
        }),
      }).catch(function () {});
    } catch (e) {}
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-wild-savecart-form]') : null;
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[type="email"]');
    var msg = form.parentElement.querySelector('[data-wild-savecart-msg]');
    var email = ((input && input.value) || '').trim();
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      showMsg(msg, 'Please enter a valid email address.', true);
      if (input) input.focus();
      return;
    }
    var key = form.getAttribute('data-kl-key');
    var list = form.getAttribute('data-kl-list');
    var evt = form.getAttribute('data-kl-event') || 'Saved Cart';
    var btn = form.querySelector('button[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        fireKlaviyo(email, evt, cart);
        subscribeList(email, key, list);
        showMsg(msg, form.getAttribute('data-kl-success') || 'Done, check your inbox.', false);
        form.style.display = 'none';
      })
      .catch(function () {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
        showMsg(msg, 'Something went wrong. Please try again.', true);
      });
  });
})();
